module.exports = __webpack_public_path__ + "img/munic-merlo.3abe01af.png";